export default "__VITE_ASSET__CUKM0aHZ__"